<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <RadioMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "NonContractOrder",
  data() {
    return {
      breadcrumb: [
        { name: "订单管理" },
        { name: "普通订单" },
      ],
      menu: [
        {
          name: "自有车辆",
          path: '/order/nocontract/own',
        },
        {
          name: "雇佣车辆",
          path: '/order/nocontract/hire',
        },
      ],
      menuIndex: '/order/nocontract/own',
    };
  },
  watch: {
    $route(to, from) {
      console.log(`from ${from.path}`)
      console.log(`to ${to.path}`)
      this.matchPath()
    },
  },
  methods: {
    matchPath() {
      this.menu.map(v => {
        if (this.$route.path.includes(v.path)) {
          this.menuIndex = v.path
        }
      })
    },
  },
  mounted() {
    this.matchPath()
  },
};
</script>
